import { render, staticRenderFns } from "./CreateCountry.vue?vue&type=template&id=35bb2179&"
import script from "./CreateCountry.vue?vue&type=script&lang=js&"
export * from "./CreateCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports